<template>
  <div class="flex grow flex-col gap-4 p-4 lg:p-0 text-center text-gray-300">
    <div v-if="brandconfig.BRAND === 'xs2event'">
      <div>
        <div v-if="!simple" class="p-4 lg:p-0 lg:flex gap-4 grid-cols-5 mb-6">
          <div v-for="item of aboutMenu" class="text-sm">
            <RouterLink v-if="item.to" :to="item.to" class="block py-1 hover:underline">{{
              $t(item.label)
            }}</RouterLink>
            <a v-else-if="item.href" target="_blank" :href="item.href" class="block py-1 hover:underline">{{
              $t(item.label)
            }}</a>
            <span
              v-else-if="item.label === 'Contact'"
              class="block py-1 cursor-pointer hover:underline"
              @click="openContactForm = true"
              >{{ $t(item.label) }}</span
            >
            <span
              v-else-if="item.label === 'Feedback'"
              class="block py-1 cursor-pointer hover:underline"
              @click="openFeedbackForm = true"
              >{{ $t(item.label) }}</span
            >
            <span v-else class="text-gray-300 block py-1">{{ $t(item.label) }}</span>
          </div>
        </div>
      </div>
      <div class="m-2">&copy; {{ new Date().getFullYear() }} XS2Event B.V. {{ $t("All rights reserved") }}.</div>
    </div>
    <component :is="simple ? 'div' : RouterLink" to="/" class="flex justify-center align-middle">
      <img class="align-middle w-8" :src="logo_mobile" alt="logo" />
      <img class="logo ml-10 scale-150 align-middle" :src="logo_footer" alt="logo" />
    </component>
  </div>
</template>
<script setup lang="ts">
import { RouterLink } from "vue-router";
import brandconfig from "@/brandconfig";
import logo_arrow from "@/assets/images/xs2_arrow_black.svg";

defineProps<{ simple?: boolean }>();

const aboutMenu = brandconfig.footer.about;
const logo_footer = brandconfig.LOGO_FOOTER;
const logo_mobile = logo_arrow;
</script>
